<template>
  <div
    v-if="renderItem"
    class="flex items-center"
    :class="image ? 'gap-16' : 'gap-8'"
  >
    <DynamicIcon v-if="icon" class="shrink-0" v-bind="icon" />

    <ImageRenderer
      v-if="image"
      :alt="text || ''"
      class="w-64 h-48"
      :height="image.height"
      :height-mobile="image.heightMobile"
      :src="image.src"
      :src-mobile="image.srcMobile"
      :width="image.width"
      :width-mobile="image.widthMobile"
    />

    <div v-if="text" class="body-2-bold">{{ text }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ListItemApiProps } from '@backmarket/http-api/src/api-specs-content/models/list-item'

import type { BlockProps } from '../../models/content-block'
import DynamicIcon from '../../shared-components/DynamicIcon/DynamicIcon.vue'
import ImageRenderer from '../../shared-components/ImageRenderer/ImageRenderer.vue'

export type ListItemBlockProps = ListItemApiProps & BlockProps

const props = defineProps<ListItemBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error', 'reset-error', 'loaded'])

const renderItem = props.icon || props.image || props.text
</script>
